shvenergy.tracking = (function ($) {
	"use strict";

	designstudioTracking();
	dixaTracking();
	hubspotTracking();

	function designstudioTracking() {
  	$(window).on('load', function () {
			// Designstudio used on fx calor.co.uk
			var $designstudio = $("#iframe-designstudio-button");
			if ($designstudio.length === 0) {
				return;
			}
			$designstudio[0].contentDocument.addEventListener('click', function() {
                var eventData = {
            "event": "trackEvent",
	        "eventData": {
	            "category": "Chat",
	            "action": "Click"
	        }
	      };
	      var dataLayer = window.dataLayer;
	      if (!dataLayer) {
	        console.log("Tracking not enabled:", eventData);
	        return;
	      }
	      dataLayer.push(eventData);
			}, false);

		})
	}

	function dixaTracking() {
		$(window).on('load', function() {
			// Dixa used on fx primagaz.dk
			var $dixa = $("#dixa-widget-wrapper");
			if ($dixa.length === 0) {
				return;
			}
			$dixa[0].contentDocument.addEventListener('click', function() {
                var eventData = {
            "event": "trackEvent",
	        "eventData": {
	            "category": "Chat",
	            "action": "Click"
	        }
	      };
	      var dataLayer = window.dataLayer;
	      if (!dataLayer) {
	        console.log("Tracking not enabled:", eventData);
	        return;
	      }
	      dataLayer.push(eventData);
			}, false);
		})
	}

	function hubspotTracking() {
		$(window).on('load', function() {
			// Hubspot used on fx primagas.es
			var $hubspot = $("#hubspot-messages-iframe-container iframe");
			if ($hubspot.length === 0) {
				return;
			}
			$hubspot[0].contentDocument.addEventListener('click', function() {
                var eventData = {
            "event": "trackEvent",
	        "eventData": {
	            "category": "Chat",
	            "action": "Click"
	        }
	      };
	      var dataLayer = window.dataLayer;
	      if (!dataLayer) {
	        console.log("Tracking not enabled:", eventData);
	        return;
	      }
	      dataLayer.push(eventData);
			}, false);
		})
	}

})(jQuery);